import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsPositionWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_POSITION;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsPositionWUT
};
//# sourceMappingURL=contacts-position-wut.js.map
